/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Preview_Nav_ClientsInputs */

const en_landing_preview_nav_clients = /** @type {(inputs: Landing_Preview_Nav_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clients`)
};

/**
* | output |
* | --- |
* | "Clients" |
*
* @param {Landing_Preview_Nav_ClientsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_preview_nav_clients = /** @type {((inputs?: Landing_Preview_Nav_ClientsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Preview_Nav_ClientsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_preview_nav_clients(inputs)
});